import { cn } from '../../lib/utils';
import { Card } from '../ui/card';
import { Skeleton } from '../ui/skeleton';

interface StatCardProps {
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  label: string;
  value: number | string | undefined;
  delta?: string;
  loading?: boolean;
  size?: 'sm';
}

export function StatCardSkeleton() {
  return (
    <Card>
      <div className="flex items-start gap-4">
        <Skeleton className="h-12 w-12 rounded-xl shrink-0 mt-0.5" />
        <div className="flex-1">
          <Skeleton className="h-10 w-16 mb-1" />
          <Skeleton className="h-4 w-28" />
        </div>
      </div>
    </Card>
  );
}

export function StatCard({
  icon,
  iconBg,
  iconColor,
  label,
  value,
  delta,
  loading,
  size,
}: StatCardProps) {
  const sm = size === 'sm';
  return (
    <Card className={cn('hover:shadow-md transition-shadow', sm && 'p-4 md:p-4')}>
      <div className="flex items-start gap-3">
        <div
          className={cn(
            'flex items-center justify-center rounded-xl shrink-0 mt-0.5',
            sm ? 'h-9 w-9' : 'h-12 w-12',
            iconBg,
          )}
        >
          <span
            className={cn(iconColor, sm ? '[&>svg]:h-4 [&>svg]:w-4' : '[&>svg]:h-6 [&>svg]:w-6')}
          >
            {icon}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          {loading ? (
            <Skeleton className={cn('mb-1', sm ? 'h-7 w-12' : 'h-10 w-16')} />
          ) : (
            <div
              className={cn('font-bold tracking-tight text-gray-900', sm ? 'text-2xl' : 'text-4xl')}
            >
              {value ?? 0}
            </div>
          )}
          <div className={cn('text-gray-500 mt-0.5', sm ? 'text-xs' : 'text-sm')}>{label}</div>
        </div>
        {delta && (
          <span className="text-[11px] leading-tight text-right max-w-[80px] text-gray-400 self-start shrink-0">
            {delta}
          </span>
        )}
      </div>
    </Card>
  );
}
